import { postFormData } from "../api";
import { showToast } from "../common";

function setEditingState(container, editing) {
  const display = container.querySelector(".sheet-effective-date__display");
  const form = container.querySelector("[data-sheet-effective-date-form]");
  const input = container.querySelector("[data-sheet-effective-date-input]");

  if (!(display instanceof HTMLButtonElement) || !(form instanceof HTMLFormElement)) {
    return;
  }

  display.hidden = editing;
  form.hidden = !editing;

  if (editing && input instanceof HTMLInputElement) {
    input.focus();
    input.showPicker?.();
  }
}

function setPendingState(container, pending) {
  container.querySelectorAll("button, input").forEach((element) => {
    element.disabled = pending;
  });
}

export function initSheetEffectiveDates(root = document) {
  if (!(root instanceof Document || root instanceof Element)) {
    return;
  }

  root.querySelectorAll("[data-sheet-effective-date]").forEach((container) => {
    if (!(container instanceof HTMLElement) || container.dataset.sheetEffectiveDateInitialized === "1") {
      return;
    }

    const display = container.querySelector(".sheet-effective-date__display");
    const form = container.querySelector("[data-sheet-effective-date-form]");
    const input = container.querySelector("[data-sheet-effective-date-input]");
    const cancel = container.querySelector("[data-sheet-effective-date-cancel]");
    const label = container.querySelector("[data-sheet-effective-date-label]");

    if (
      !(display instanceof HTMLButtonElement) ||
      !(form instanceof HTMLFormElement) ||
      !(input instanceof HTMLInputElement) ||
      !(cancel instanceof HTMLButtonElement) ||
      !(label instanceof HTMLTimeElement)
    ) {
      return;
    }

    container.dataset.sheetEffectiveDateInitialized = "1";

    display.addEventListener("click", () => setEditingState(container, true));
    cancel.addEventListener("click", () => {
      input.value = label.dateTime;
      setEditingState(container, false);
    });
    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        input.value = label.dateTime;
        setEditingState(container, false);
      }
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      if (!input.reportValidity()) {
        return;
      }

      setPendingState(container, true);

      try {
        const formData = new FormData();
        formData.set("data_obowiazywania", input.value);
        const payload = await postFormData(
          String(container.dataset.saveUrl || ""),
          formData,
          String(container.dataset.csrfToken || ""),
        );
        const effectiveDate = String(payload?.effectiveDate || input.value);
        const effectiveDateLabel = String(payload?.effectiveDateLabel || effectiveDate);

        label.dateTime = effectiveDate;
        label.textContent = effectiveDateLabel;
        input.value = effectiveDate;
        setEditingState(container, false);
        showToast(payload?.message || "Zapisano datę obowiązywania.", { type: "success" });
      } catch (error) {
        showToast(String(error?.message || "Nie udało się zapisać daty obowiązywania."), { type: "danger" });
      } finally {
        setPendingState(container, false);
      }
    });
  });
}
